import { mediaBreakpointLowerThanMd } from 'core/layouts/ui-blocks/ReusableStyles';

export const layoutStyles = {
	page: {
		width: '100%',
		minHeight: '100dvh',

		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',

		[mediaBreakpointLowerThanMd]: {
			alignItems: 'start',
			overflow: 'scroll',
		},
	},

	fixedHeaderWrapper: {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,

		zIndex: 1010,
	},
};
